/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import Loading from 'react-loading';
import styled from 'styled-components';
import { MdClose } from 'react-icons/md';

import moment from 'moment-timezone';
// import qs from 'query-string';

import {
  Pagination,
  Table,
  // Pagination
} from '../../../components/elements';
import { fetchUserLoginHistory } from './helper';
import LoginTableDetails from './LoginTableDetails';
import RefreshButton from './RefreshButton';

const Container = styled.form`
  &&& {
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      height: 100vh;
      padding: 0px;
    }
    .modal-card {
      max-height: calc(100vh - 0px);
      position: absolute;
      right: 0;
      width: 35rem;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      justify-content: center;
      border-bottom: 0px;
      padding: 1rem 2rem;
      padding-top: 1.5rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: center;
      background: white;
      border-top: 0px;
      .button {
        font-weight: 600;
      }
    }
    .full-width {
      width: 100%;
    }
  }
`;

const MobileContainer = styled.form`
  &&& {
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      padding: 0px;
    }
    .modal-card {
      width: 100vw;
      height: 100vh;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      justify-content: center;
      border-bottom: 0px;
      padding: 1rem 2rem;
      padding-top: 1.5rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: center;
      background: white;
      border-top: 0px;
      .button {
        font-weight: 600;
      }
    }
    .full-width {
      width: 100%;
    }
  }
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  left: 1rem;
  top: 1.2rem;
  cursor: pointer;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const SpecialSpacingHr = styled.div`
  padding: 0.5rem 0rem;
  border-bottom: 1px solid #dbdbdb;
`;

const OrderDisplayedContainer = styled.div`
  padding: 0.6rem;
  margin-bottom: 1rem;
  margin-bottom: 1rem;
`;

const AesDes = ({ sort, setSort, aes, des }) => (
  <a onClick={() => setSort(sort === des ? aes : des)}>
    <i className={`fas fa-sort-amount-${sort === des ? 'up' : 'down'}`} />
  </a>
);

function isMobileView() {
  return window?.matchMedia?.('(max-width: 768px)').matches || false;
}

const FormLayout = ({ children, isActive }) => {
  const isMobile = isMobileView();

  if (isMobile) {
    return (
      <MobileContainer
        className={`modal ${isActive && 'is-active'}`}
        onSubmit={e => {
          e.preventDefault();
        }}
      >
        {children}
      </MobileContainer>
    );
  }

  return (
    <Container
      className={`modal ${isActive && 'is-active'}`}
      onSubmit={e => {
        e.preventDefault();
      }}
    >
      {children}
    </Container>
  );
};

const LoginTable = ({
  placeId,
  // routeState,
  // history
}) => {
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  // totalElements,
  const [totalElements, setTotalElements] = React.useState();
  const listSize = 10;
  const currentPage = parseInt(page, 10) - 1 >= 0 ? parseInt(page, 10) - 1 : 0;
  const [sort, setSort] = React.useState('UPDATED_DESC');

  const [loading, setLoading] = React.useState(false);
  const [userLoginHistoryData, setUserLoginHistoryData] = React.useState([]);

  const [activeLogItem, setActiveLogItem] = React.useState(null);

  console.log('activeLogItem', activeLogItem);

  const [isActiveLogDetail, setIsActiveLogDetail] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await fetchUserLoginHistory({
          placeId,
          sort,
          from: currentPage * listSize,
          size: listSize,
        });
        setPageCount(data.total_pages);
        setTotalElements(data.total_size);
        setUserLoginHistoryData(
          (data.user_login_history ?? []).filter(
            ele => ele.app_type === 'PARTNER_APP',
          ),
        );
        setLoading(false);
      } catch {
        setLoading(false);
      }
    };
    fetchData();
  }, [placeId, sort, currentPage]);

  return (
    <>
      <FormLayout isActive={isActiveLogDetail}>
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <CloseButtonWrapper>
              <MdClose
                size={30}
                type="button"
                onClick={() => {
                  setIsActiveLogDetail(false);
                  setActiveLogItem(null);
                }}
              />
            </CloseButtonWrapper>
            <HeaderContent>
              <p className="modal-card-title is-uppercase">Log Details</p>
            </HeaderContent>
          </header>
          <section className="modal-card-body">
            <LoginTableDetails
              logObject={activeLogItem}
              refreshButton={() => (
                <RefreshButton
                  requestObject={{
                    id:
                      activeLogItem?.['Place ID'] ??
                      'admin_testing_place_id_latest',
                    deviceId:
                      activeLogItem?.['Unique ID'] ??
                      'admin_testing_unique_id_latest',
                    email: activeLogItem?.Email ?? 'admin_testing_email_latest',
                  }}
                />
              )}
            >
              {({ data, open, onClose }) => (
                <>
                  <FormLayout isActive={open}>
                    <div className="modal-background" />
                    <div className="modal-card">
                      <header className="modal-card-head">
                        <CloseButtonWrapper>
                          <MdClose size={30} type="button" onClick={onClose} />
                        </CloseButtonWrapper>
                        <HeaderContent>
                          <p className="modal-card-title is-uppercase">
                            Orders Not Displayed
                          </p>
                        </HeaderContent>
                      </header>
                      <section className="modal-card-body">
                        <OrderDisplayedContainer>
                          {(data ?? []).map(ele => (
                            <>
                              <SpecialSpacingHr>
                                <p className="is-size-3 has-text-weight-semibold">
                                  {ele}
                                </p>
                              </SpecialSpacingHr>
                            </>
                          ))}
                        </OrderDisplayedContainer>
                      </section>
                    </div>
                  </FormLayout>
                </>
              )}
            </LoginTableDetails>
          </section>
          <a
            className="button is-large is-fullwidth is-primary"
            onClick={() => {
              setIsActiveLogDetail(false);
              setActiveLogItem(null);
            }}
          >
            Done
          </a>
        </div>
      </FormLayout>
      {totalElements > 0 && (
        <Pagination
          pageFrom={currentPage * listSize}
          pageCount={pageCount}
          listSize={listSize}
          totalElements={totalElements}
          currentPage={currentPage}
          handlePageClick={value => {
            setPage(value.selected + 1);
          }}
        />
      )}

      <div style={{ padding: '10px' }}>
        <Table>
          {!loading && userLoginHistoryData.length !== 0 && (
            <>
              <thead>
                <tr>
                  {[
                    'Email',
                    'Login Date & Time',
                    'Logged In',
                    'App Version',
                    'App Build Number',
                    'IP Address',
                    'Device Name',
                    'Platform',
                  ].map((headerCellValue, index) => (
                    <th
                      style={{ fontWeight: 700 }}
                      key={`${headerCellValue}-${index}`}
                    >
                      {headerCellValue === 'Login Date & Time' ? (
                        <div>
                          <span>
                            <AesDes
                              sort={sort}
                              setSort={setSort}
                              aes="UPDATED_ASC"
                              des="UPDATED_DESC"
                            />
                            {headerCellValue}
                          </span>
                        </div>
                      ) : (
                        <div>
                          <span>{headerCellValue}</span>
                        </div>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {userLoginHistoryData.map((lhData, index) => (
                  <tr key={`${placeId}-${index}`}>
                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        cursor: 'pointer',
                        color: '#00AEEF',
                      }}
                      onClick={() => {
                        setIsActiveLogDetail(true);
                        setActiveLogItem({
                          user_id: lhData?.user_id,
                          Email: lhData?.email,
                          'First Name': lhData?.first_name,
                          'Last Name': lhData?.last_name,
                          'Login Date & Time': moment(lhData?.login_at).format(
                            'LLL',
                          ),
                          'Last Synced Date & Time': moment(
                            lhData?.last_login,
                          ).format('LLL'),

                          'App Version': lhData.version_number,
                          'App Build Number': lhData.build_number,
                          'Unique ID': lhData.unique_id,
                          'Place ID': lhData.place_id,
                          'IP Address': lhData.ip_address,
                          Model: lhData.model_number,
                          'Device Name': lhData.device_name,
                          'Android Version': lhData.android_version,
                          'Orders Displayed': lhData.orders_displayed,
                          'App Foreground Status': lhData.power_on_or_not,
                          'App Internet Status': lhData.internet_on_or_not,
                          'Printer Status': lhData.printer_status,
                          'Display New Order Notification For Auto Confirm': !lhData.display_new_order_notification_for_auto_confirm
                            ? 'OFF'
                            : 'ON',
                          'Display New Order Notification For All Venues': !lhData.display_new_order_notification_for_all_venues
                            ? 'OFF'
                            : 'ON',
                          'Play New Order Sound For All Venues': !lhData.play_new_order_sound_for_all_venues
                            ? 'OFF'
                            : 'ON',
                          'Print New Order For All Venues': !lhData.print_new_order_for_all_venues
                            ? 'OFF'
                            : 'ON',
                          'Print On Order Confirmation': !lhData.print_on_order_confirmation
                            ? 'OFF'
                            : 'ON',
                          'Print On Order Received': !lhData.print_on_order_received
                            ? 'OFF'
                            : 'ON',
                          'Print Special Characters': !lhData.print_special_characters
                            ? 'OFF'
                            : 'ON',
                          'Sound Preference Value':
                            lhData.sound_preference_value,
                        });
                      }}
                    >
                      {lhData.email}
                    </td>
                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        cursor: 'pointer',
                        color: '#00AEEF',
                      }}
                      onClick={() => {
                        setIsActiveLogDetail(true);
                        setActiveLogItem({
                          user_id: lhData?.user_id,
                          Email: lhData?.email,
                          'First Name': lhData?.first_name,
                          'Last Name': lhData?.last_name,
                          'Login Date & Time': moment(lhData?.login_at).format(
                            'LLL',
                          ),
                          'Last Synced Date & Time': moment(
                            lhData?.last_login,
                          ).format('LLL'),

                          'App Version': lhData.version_number,
                          'App Build Number': lhData.build_number,
                          'Unique ID': lhData.unique_id,
                          'Place ID': lhData.place_id,
                          'IP Address': lhData.ip_address,
                          Model: lhData.model_number,
                          'Device Name': lhData.device_name,
                          'Android Version': lhData.android_version,
                          'Orders Displayed': lhData.orders_displayed,
                          'App Foreground Status': lhData.power_on_or_not,
                          'App Internet Status': lhData.internet_on_or_not,
                          'Printer Status': lhData.printer_status,
                        });
                      }}
                    >
                      {moment(lhData?.login_at).format('LLL')}
                    </td>
                    <td>{lhData.logged_in ? 'TRUE' : 'FALSE'}</td>
                    <td>{lhData.version_number}</td>
                    <td>{lhData.build_number}</td>
                    <td>{lhData.ip_address}</td>
                    <td>{lhData.device_name}</td>
                    <td>{lhData.platform}</td>
                  </tr>
                ))}
              </tbody>
            </>
          )}
        </Table>
        {loading && (
          <Center>
            <Loading type="spin" color="#363636" width="60px" height="60px" />
          </Center>
        )}
      </div>
    </>
  );
};

export default LoginTable;
